import { render, staticRenderFns } from "./RenewPassword.vue?vue&type=template&id=1b00dcfe&scoped=true&"
import script from "./RenewPassword.vue?vue&type=script&lang=js&"
export * from "./RenewPassword.vue?vue&type=script&lang=js&"
import style0 from "./RenewPassword.vue?vue&type=style&index=0&id=1b00dcfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b00dcfe",
  null
  
)

export default component.exports